import { createContext, useContext } from 'react';

/**
 * The key of the day the board is showing (`d0`, `d1`, …), which is what the
 * signup sheet's availability slots are keyed by.
 *
 * Reached through a context for the same reason as the axis: only the
 * innermost block — a shift's resize handles asking whether the new hours run
 * into a closed slot — wants it, and it would otherwise be a parameter on
 * every component between the board and there.
 */
export const DayContext = createContext<string>('');

export function useDayKey() {
  return useContext(DayContext);
}
